<template>
  <div class="app flex-row align-items-center login-bg">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body style="width:44%">
              <!-- <b-card-body class="text-center">
                <div> -->
                  <img src="static/img/login_left.jpg" height="100%" width="100%">
                <!-- </div>
              </b-card-body> -->
            </b-card>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>Login</h1>
                <p class="text-muted">{{msg}}</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                  <input type="text" v-model="email" class="form-control" placeholder="Username">
                </b-input-group>
                <b-input-group class="mb-4">
                  <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                  <input type="password" v-model="password" class="form-control" placeholder="Password">
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                    <b-button variant="primary" v-on:click="loginSubmit(email, password)" class="px-4">Login</b-button>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <!-- <b-button variant="link" class="px-0">Forgot password?</b-button> -->
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import swal from 'sweetalert2'

export default {
  name: 'Login',
  data(){
    return {
        email: '',
        password: '',
        msg: 'Sign In to your account',
        localIP : '',
    }
  },
  mounted: function() {
    var self = this;
    $.getJSON('http://gd.geobytes.com/GetCityDetails?callback=?', function(data) {
      // console.log(data.geobytesremoteip);
      self.localIP = data.geobytesremoteip;
      // console.log(self.localIP);

    });
  },
  methods:{
    // loginSubmit(email, password){
    //   if(this.localIP == "1.235.197.2" || this.localIP == "1.235.197.3" ){
    //     var params = 'grant_type=password&username='+email +'&password='+password;
    //     this.loginProc(params);
    //   }else{
    //     swal({
    //       type: 'error',
    //       title: '접근불가',
    //       text: 'DMC미디어 사내 망에서만 접근 가능합니다.',
    //       footer: ''
    //     })
    //   }
    // },
    loginSubmit(email, password){
      var params = 'grant_type=password&username='+email +'&password='+password;
      this.loginProc(params);
    },
    loginProc(params){
      this.$http.post("/login?" + params)
      .then((result) => {
        var self = this;
        var http = new XMLHttpRequest();
        var url = self.$store.getters.getAPIDomain + '/oauth/token';

        http.open('POST', url, true);
        //Send the proper header information along with the request
        http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        http.setRequestHeader('Authorization', self.$store.getters.getCredentialCode);
        // console.log('크리덴셜 : ' + self.$store.getters.getCredentialCode);
        var redirect = function(){
          self.$router.push("/dashboard") // redirect
        }

        http.onreadystatechange = function() { //Call a function when the state changes.
            if(http.readyState == 4 && http.status == 200) {

                // 유저 정보 저장
                self.$http.get("/select/user?" + params)
                      .then((resultUser) => {

                        self.$session.set('userInfo', resultUser.data);

                        var result = JSON.parse(http.responseText);
                        self.$store.dispatch('LOGIN', result);
                        redirect();

                      });
            }
        }

        this.$session.start();
        this.$session.set('email', this.email);


        http.send(params);
      })
      .catch((error) =>{
        this.msg = error.response.data.message;
      })
    }
  }
}
</script>
<style scoped>
.login-bg{
  background-image: url("/static/img/bg.jpg");
      background-repeat: no-repeat;
      background-position: center; /* Center the image */
      background-size: cover; /* Resize the background image to cover the entire container */
}
</style>



// WEBPACK FOOTER //
// src/views/pages/Login.vue